import axios from '../plugins/axios';

const API_URL = '/admin/spaces';

export default {
  async getSpaces(filters = {}) {
    let url = API_URL;
    
    if (filters.name) {
      url += `?_filters_[]=name__contains&name__contains=${encodeURIComponent(filters.name)}`;
    }
    
    console.log('API Request URL:', url);
    
    try {
      const response = await axios.get(url);
      console.log('API Response:', response.data);
      return response.data;
    } catch (error) {
      console.error('API Error:', error);
      throw error;
    }
  },

  async addSpace(spaceData) {
    const response = await axios.post(API_URL, spaceData);
    return response.data;
  },

  async updateSpace(spaceId, spaceData) {
    const response = await axios.put(`${API_URL}/${spaceId}`, spaceData);
    return response.data;
  },

  async deleteSpace(spaceId) {
    const response = await axios.delete(`${API_URL}/${spaceId}`);
    return response.data;
  }
}; 